import { useMemo } from 'react';
import {
  GetAutoAcceptSettingsQuery,
  useGetAutoAcceptSettingsQuery
} from 'graphql/types';

export const useAutoAcceptSettings = (): {
  data: GetAutoAcceptSettingsQuery | undefined;
  loading: boolean;
} => {
  const { loading, data } = useGetAutoAcceptSettingsQuery({
    fetchPolicy: 'cache-and-network'
  });

  return useMemo(
    () => ({
      loading,
      data
    }),
    [data, loading]
  );
};
